export default () => {
    return {
        typeLookup: {
            CRM: [
                {
                    id: '5da5bd80-6488-4e76-a36d-f165b3991168',
                    isActive: true
                }
            ]
        },
        dashboards: {
            '5da5bd80-6488-4e76-a36d-f165b3991168': {
                id: '5da5bd80-6488-4e76-a36d-f165b3991168',
                name: 'Untitled',
                type: 'CRM',
                modified: '2022-07-15 04:15:14.350881',
                isActive: true,
                widgetIds: [
                    'e18d6c0a-a785-4cfe-b97a-951a4961d0ae',
                    'f16aa774-e2c4-4805-b265-7b2bf625eb5b'
                ]
            }
        },
        widgets: {
            'e18d6c0a-a785-4cfe-b97a-951a4961d0ae': {
                dashboardId: '5da5bd80-6488-4e76-a36d-f165b3991168',
                i: 'e18d6c0a-a785-4cfe-b97a-951a4961d0ae',
                w: 30,
                h: 3,
                x: 0,
                y: 0,
                isResizable: true,
                component: 'patient-lookup-widget',
                config: {},
                moved: false
            },
            'f16aa774-e2c4-4805-b265-7b2bf625eb5b': {
                dashboardId: '5da5bd80-6488-4e76-a36d-f165b3991168',
                i: 'f16aa774-e2c4-4805-b265-7b2bf625eb5b',
                w: 30,
                h: 3,
                x: 30,
                y: 0,
                isResizable: true,
                component: 'request-lookup-widget',
                config: {},
                moved: false
            }
        },
        currentDraggedWidget: null
    }
}
